let baseUrl = process.env.VUE_APP_BASE_URL
let Host = process.env.VUE_APP_BASE_HOST
export default {
  apiUrl: `${Host}.${baseUrl}`,
  casLogin: `https://cas.${baseUrl}/cas/login.html`
}
